"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBytes = void 0;
const hexRegularPattern = /^0x[0-9a-fA-F]+/;
function isBytes(value, exponent) {
    const byteSize = (value.length - 2) / 2;
    return byteSize === exponent && hexRegularPattern.test(value);
}
exports.isBytes = isBytes;
